var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex align-items-center" },
    [
      _c("h6", { staticClass: "m-0" }, [_vm._v(_vm._s(_setup.props.title))]),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [{ name: "tippy", rawName: "v-tippy" }],
        staticClass: "ml-auto mr-1",
        attrs: {
          content: "Copy Color Options",
          size: "icon",
          icon: ["far", "copy"],
          disabled: !_vm.canCopy,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("copy")
          },
        },
      }),
      _vm._v(" "),
      _c(_setup.CButton, {
        directives: [{ name: "tippy", rawName: "v-tippy" }],
        attrs: {
          content: "Paste Color Options",
          size: "icon",
          icon: ["far", "paste"],
          disabled: !_vm.canPaste,
        },
        on: {
          click: function ($event) {
            return _vm.$emit("paste")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }